import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DrawingLinkedDay, DrawingLinkedRecord } from '../../../../../../../../shared/models/drawing-sheet';
import { dayTitle, groupLinkedByDay, isOpenStatus, LinkedDayGroup, linkedRecordNoun } from '../drawing-markers';

/** "Linked here": the records marked on a revision, by day, newest first. Clicking a row selects its marker. */
@Component({
  selector: 'app-drawing-linked-panel',
  templateUrl: './drawing-linked-panel.component.html',
  styleUrls: ['./drawing-linked-panel.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawingLinkedPanelComponent implements OnChanges {
  @Input() rows: DrawingLinkedRecord[] = [];
  @Input() days: DrawingLinkedDay[] = [];
  @Input() totalRecords = 0;
  @Input() start = 0;
  @Input() pageSize = 20;
  @Input() selectedUuid: string | null = null;
  @Input() loading = false;
  @Output() selectRecord = new EventEmitter<DrawingLinkedRecord>();
  @Output() openRecord = new EventEmitter<DrawingLinkedRecord>();
  @Output() pageChange = new EventEmitter<number>();

  groups: LinkedDayGroup[] = [];
  readonly isOpen = isOpenStatus;
  readonly noun = linkedRecordNoun;
  readonly dayTitle = dayTitle;

  get rangeText(): string {
    const last = Math.min(this.start + this.rows.length, this.totalRecords);
    return `${this.start + 1}–${last} of ${this.totalRecords}`;
  }

  get hasPrev(): boolean {
    return this.start > 0;
  }

  get hasNext(): boolean {
    return this.start + this.pageSize < this.totalRecords;
  }

  ngOnChanges(): void {
    this.groups = groupLinkedByDay(this.rows ?? [], this.days ?? [], this.start);
  }

  open(row: DrawingLinkedRecord, event: Event): void {
    event.stopPropagation();
    this.openRecord.emit(row);
  }

  prev(): void {
    this.pageChange.emit(Math.max(0, this.start - this.pageSize));
  }

  next(): void {
    this.pageChange.emit(this.start + this.pageSize);
  }
}
